/* ------------------------------------------------------------------
   Mr Football - "Build your kit": layout, size gate, and cart.
   Markup in snippets/mf-kit-builder.liquid.

   ================================================================
   1. PAGE ORDER, AND WHY THESE BLOCKS GET MOVED OUT
   ================================================================
   The theme renders its variant container in an order nobody would
   choose: the SIZE SWATCHES COME LAST, below the size-guide link, the
   offer banner and everything we add. So the shopper met "Build your
   kit" before they had picked a size.

   The order we want, and why:

     price / reviews        already above - trust before anything
     "shorts included"      a fact about the product, stays high
     SIZE + size guide      the first real decision. Nothing else can
                            be decided until this is
     BUILD YOUR KIT         upsells, only once the base choice is made
     THE HAT-TRICK          the offer, sat directly above the button
                            where it can still change the basket
     buy

   (The quantity box used to sit between the offer and the button. It
   was hidden on every product page on 2026-10-10 at the owner's
   request - it was the anchor for all of this, so removing it in the
   theme editor made the whole column collapse. See qtyBlock().)

   !! THE BLOCKS MUST LIVE OUTSIDE .js-variant-selector !!
   Changing size makes the theme re-render that whole container. An
   earlier version only reordered things inside it, and on the first
   size tap everything snapped back AND the offer banner appeared twice
   - the re-render emits a fresh copy while the moved one still exists.
   Worse, a re-render would wipe a typed name and any chosen badge.

   So our blocks move OUT to section level, and on every re-render we
   delete the fresh copies the theme emits inside the container. The
   node the shopper is touching is never the one that gets destroyed.
   The theme's own swatches stay exactly where they are - this theme
   caches nodes at init (part 3) and moving its elements breaks it.

   !! DO NOT ANCHOR OFF form[action="/cart/add"]. !!
   There are TWO of them on a product page. querySelector returns one
   nested inside .product__section--header which has no next sibling, so
   insertBefore(el, form.nextSibling) silently degrades into append and
   the block lands at the very bottom of the page. That is exactly what
   happened on 2026-10-02. Anchor off .product__section--qty, which is
   unique and is the thing we actually want to sit above.

   ================================================================
   2. THE SIZE GATE
   ================================================================
   The builder starts locked. The theme preselects the first size, so
   without a gate a shopper could print a name onto a size they never
   consciously chose - and printed shirts cannot be exchanged. One tap
   on any size unlocks it for that page view. Arriving on a ?variant=
   link counts as already chosen.

   ================================================================
   3. GETTING THINGS INTO THE CART
   ================================================================
   Name and number are a LINE ITEM PROPERTY on the shirt. The badge and
   the shorts are SEPARATE PRODUCTS, because Shopify cannot charge for a
   property - it is free text with no price.

   BADGES ARE ONE ONLY. The tiles behave like radio buttons: choosing
   one clears the rest, and tapping the chosen one clears it. If this is
   ever reverted to multi-select, extras() already handles a list, so
   only the click handler below needs changing.

   !! WHY WE WRITE INTO THE THEME'S OWN FIELD AND NOT OUR OWN INPUT !!
   Measured on the storefront 2026-10-02, not assumed. This theme does
   NOT serialize the product form and does NOT re-query the DOM on
   submit. It captures its line-item-property fields ONCE at init.
   Two experiments, both of which reached the cart as nothing:
     * a hidden properties[] input appended to <form action="/cart/add">
     * a hidden properties[] input appended to the SAME PARENT as the
       theme's own field, `.line-item-property__field`
   Only the field present at page load arrived. So we keep the theme's
   `properties[Enter Name & Number (FREE)]` input in the DOM under its
   original name, hide its wrapper, and write "NAME NUMBER" into it.
   Do NOT rename it and do NOT detach it. If it is missing, the Name &
   number row hides itself rather than collect something that would be
   silently dropped.

   !! NO MutationObserver IN THIS FILE. !!
   An earlier version re-ran everything on any DOM change. syncTotal()
   writes textContent, which IS a childList mutation, so it retriggered
   itself and locked the main thread - the page stopped responding to
   script entirely. setText() only writes when the value changed.

   The add-to-cart intercept runs in the CAPTURE phase so it goes first:
   cancel the click, POST the extras, then re-fire the same click with a
   one-shot flag. If the extras POST fails we add the shirt anyway -
   losing a badge is annoying, losing the sale is worse.
------------------------------------------------------------------ */
(function () {
  'use strict';
  if (window.__mfKitBuilder) { return; }
  window.__mfKitBuilder = true;

  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }
  function setText(el, txt) {
    if (el && el.textContent !== txt) { el.textContent = txt; }
  }
  function root() { return document.querySelector('[data-mf-kit-builder]'); }
  function carrier() {
    return document.querySelector('input[name^="properties[Enter Name"]');
  }
  /* The container the theme destroys and rebuilds on every size change. */
  function volatileBox() { return document.querySelector('.js-variant-selector'); }
  /* THE ANCHOR EVERYTHING IS PLACED ABOVE.

     !! SCOPED TO THE MAIN PRODUCT COLUMN. NEVER A BARE querySelector. !!
     A product page carries several MORE .product__section--qty boxes:
     one inside every hidden quick-add form in the product grids lower
     down (.product--grid_add). While the main Quantity block existed,
     document.querySelector happened to hit it first. When the owner
     removed Quantity in the theme editor, it hit a grid quick-add box
     instead, and place() moved Build your kit and the hat-trick INSIDE
     that hidden form - the column collapsed and the blocks vanished.
     Found on the storefront 2026-10-10 by deleting the block in place.

     So: the main column's own quantity block if it has one (it is
     hidden with CSS but still marks the spot above the buy button),
     otherwise the main column's buy-buttons block. Both are direct
     children of .product__section-details and each has limit 1. */
  function qtyBlock() {
    var col = document.querySelector('.product__section-details');
    if (!col) { return null; }
    var kids = col.children;
    var buttons = null;
    for (var i = 0; i < kids.length; i++) {
      if (kids[i].classList.contains('product__section--qty')) { return kids[i]; }
      if (!buttons && kids[i].classList.contains('product__section--buttons')) { buttons = kids[i]; }
    }
    return buttons;
  }

  /* ================= 1. page order ================= */

  function keepOne(selector) {
    var box = volatileBox();
    var all = [].slice.call(document.querySelectorAll(selector));
    if (!all.length) { return null; }
    var keep = null;
    if (box) {
      for (var i = 0; i < all.length; i++) {
        if (!box.contains(all[i])) { keep = all[i]; break; }
      }
    }
    if (!keep) { keep = all[0]; }
    for (var j = 0; j < all.length; j++) {
      if (all[j] !== keep && all[j].parentNode) {
        all[j].parentNode.removeChild(all[j]);
      }
    }
    return keep;
  }

  function place() {
    var qty = qtyBlock();
    if (!qty || !qty.parentNode) { return; }

    /* '.mf-bun', not '.mf-ht': the cart drawer's hat-trick progress line
       (snippets/mf-hat-trick-cart.liquid) is also .mf-ht, so the broader
       selector would have counted it as a duplicate and deleted it. */
    var ht = keepOne('.mf-bun');
    if (ht && qty.previousElementSibling !== ht) {
      qty.parentNode.insertBefore(ht, qty);
    }

    var kb = keepOne('.mf-kb');
    var anchor = (ht && ht.parentNode) ? ht : qty;
    if (kb && anchor.previousElementSibling !== kb) {
      anchor.parentNode.insertBefore(kb, anchor);
    }
  }

  /* ================= 2. size gate ================= */

  function unlock() {
    var kb = root();
    if (kb) { kb.classList.remove('is-locked'); }
  }

  function sizeTouched() {
    unlock();
    setTimeout(function () { place(); unlock(); }, 60);
    setTimeout(function () { place(); unlock(); }, 350);
    setTimeout(function () { place(); unlock(); }, 900);
  }

  function watchSize() {
    try {
      if (new URLSearchParams(window.location.search).get('variant')) { unlock(); }
    } catch (e) {}

    document.addEventListener('click', function (ev) {
      var t = ev.target;
      if (!t || !t.closest || t.closest('[data-mf-kit-builder]')) { return; }
      if (t.closest('.swatch-element') || t.closest('.js-variant-selector label')) { sizeTouched(); }
    }, true);

    document.addEventListener('change', function (ev) {
      var t = ev.target;
      if (!t || !t.closest || t.closest('[data-mf-kit-builder]')) { return; }
      if (t.closest('.js-variant-selector') || t.name === 'id') { sizeTouched(); }
    }, true);
  }

  /* ================= stock personalise field ================= */

  function hideLegacyField() {
    var legacy = carrier();
    if (!legacy || legacy.getAttribute('data-mf-hidden') === '1') { return; }
    legacy.setAttribute('data-mf-hidden', '1');
    legacy.value = '';
    var wrap = legacy.closest('.product__line-item') || legacy.closest('.product__section--element') || legacy.parentElement;
    if (wrap && !wrap.querySelector('.AddtoCart')) { wrap.style.display = 'none'; }
    var labels = document.querySelectorAll('.product__section--text.rte');
    for (var i = 0; i < labels.length; i++) {
      if (/personalize/i.test(labels[i].textContent) && !labels[i].querySelector('input')) {
        labels[i].style.display = 'none';
      }
    }
  }

  function gateNameRow() {
    var r = root();
    if (!r) { return; }
    var btn = r.querySelector('[data-mf-kb-toggle="nn"]');
    if (!btn) { return; }
    var row = btn.closest('.mf-kb__row');
    if (row) { row.hidden = !carrier(); }
  }

  /* ================= state ================= */

  function state() {
    var r = root();
    if (!r) { return null; }
    var nnBtn = r.querySelector('[data-mf-kb-toggle="nn"]');
    var badgesBtn = r.querySelector('[data-mf-kb-toggle="badges"]');
    var shortsBtn = r.querySelector('[data-mf-kb-toggle="shorts"]');
    var nameEl = r.querySelector('[data-mf-kb-name]');
    var numEl = r.querySelector('[data-mf-kb-number]');
    var shortsSel = r.querySelector('[data-mf-kb-shorts]');
    return {
      r: r,
      nnOn: !!(nnBtn && nnBtn.getAttribute('aria-pressed') === 'true'),
      name: nameEl ? nameEl.value.trim().toUpperCase() : '',
      number: numEl ? numEl.value.trim() : '',
      badges: (badgesBtn && badgesBtn.getAttribute('aria-pressed') === 'true')
        ? [].slice.call(r.querySelectorAll('[data-mf-kb-badge][aria-pressed="true"]'))
        : [],
      shortsOn: !!(shortsBtn && shortsBtn.getAttribute('aria-pressed') === 'true' && shortsSel),
      shortsSel: shortsSel
    };
  }

  function syncProps() {
    var s = state();
    var c = carrier();
    if (!s || !c) { return; }
    var v = s.nnOn ? (s.name + ' ' + s.number).replace(/\s+/g, ' ').trim() : '';
    if (c.value !== v) { c.value = v; }
  }

  function syncTotal() {
    var s = state();
    if (!s) { return; }
    var cents = 0, bits = [];
    if (s.nnOn && (s.name || s.number)) {
      bits.push((s.name + ' ' + s.number).trim() + ' printed free');
    }
    s.badges.forEach(function (b) {
      cents += parseInt(b.getAttribute('data-mf-kb-price'), 10) || 0;
      var nm = b.querySelector('.mf-kb__badge-name');
      bits.push(nm ? nm.textContent.trim().toLowerCase() : 'badge');
    });
    if (s.shortsOn) {
      cents += parseInt(s.shortsSel.getAttribute('data-mf-kb-price'), 10) || 0;
      bits.push('matching shorts');
    }
    var out = s.r.querySelector('[data-mf-kb-total]');
    if (!out) { return; }
    if (!bits.length) { out.hidden = true; setText(out, ''); return; }
    out.hidden = false;
    setText(out, bits.join(' · ') + (cents > 0 ? '  —  adds ' + money(cents) : ''));
  }

  function sync() { syncProps(); syncTotal(); }

  /* ================= extras ================= */

  function extras() {
    var s = state();
    if (!s) { return []; }
    var shirt = s.r.getAttribute('data-mf-product') || 'your shirt';
    var items = [];
    s.badges.forEach(function (b) {
      items.push({
        id: parseInt(b.getAttribute('data-mf-kb-badge'), 10),
        quantity: 1,
        properties: { 'Press onto': shirt }
      });
    });
    if (s.shortsOn && s.shortsSel.value) {
      items.push({
        id: parseInt(s.shortsSel.value, 10),
        quantity: 1,
        properties: { 'Matches': shirt }
      });
    }
    return items;
  }

  function addExtras(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  /* ================= wiring ================= */

  function onClick(ev) {
    var t = ev.target;
    if (!t || !t.closest) { return; }
    var r = root();
    if (!r) { return; }

    var sw = t.closest('[data-mf-kb-toggle]');
    if (sw) {
      var key = sw.getAttribute('data-mf-kb-toggle');
      var on = sw.getAttribute('aria-pressed') !== 'true';
      sw.setAttribute('aria-pressed', String(on));
      var panel = r.querySelector('[data-mf-kb-panel="' + key + '"]');
      if (panel) { panel.hidden = !on; }
      /* Turning the badge row off clears the choice, so the shopper is
         never charged for something the closed row no longer shows. */
      if (!on && key === 'badges') {
        var opts = r.querySelectorAll('[data-mf-kb-badge]');
        for (var k = 0; k < opts.length; k++) { opts[k].setAttribute('aria-pressed', 'false'); }
      }
      if (on && key === 'nn') {
        var n = r.querySelector('[data-mf-kb-name]');
        if (n) { setTimeout(function () { try { n.focus(); } catch (e) {} }, 60); }
      }
      sync();
      return;
    }

    /* ONE BADGE ONLY - the tiles behave like radio buttons. Tapping the
       chosen one clears it, so a shopper can back out of the upsell. */
    var badge = t.closest('[data-mf-kb-badge]');
    if (badge) {
      var wasOn = badge.getAttribute('aria-pressed') === 'true';
      var all = r.querySelectorAll('[data-mf-kb-badge]');
      for (var i = 0; i < all.length; i++) { all[i].setAttribute('aria-pressed', 'false'); }
      badge.setAttribute('aria-pressed', wasOn ? 'false' : 'true');
      sync();
    }
  }

  function onAddToCart(ev) {
    var btn = ev.target && ev.target.closest ? ev.target.closest('.AddtoCart') : null;
    if (!btn || !root()) { return; }
    if (btn.__mfPass) { btn.__mfPass = false; return; }

    syncProps();
    var items = extras();
    if (!items.length) { return; }

    ev.preventDefault();
    ev.stopPropagation();
    if (ev.stopImmediatePropagation) { ev.stopImmediatePropagation(); }

    addExtras(items).then(function () {
      btn.__mfPass = true;
      btn.click();
    });
  }

  function boot() {
    if (!document.querySelector('.mf-kb')) { return; }
    place();
    hideLegacyField();
    gateNameRow();
    sync();
  }

  document.addEventListener('click', onClick, false);
  document.addEventListener('click', onAddToCart, true);
  document.addEventListener('input', function (e) {
    if (e.target && e.target.closest && e.target.closest('[data-mf-kit-builder]')) { sync(); }
  }, false);
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('[data-mf-kit-builder]')) { sync(); }
  }, false);

  watchSize();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  window.addEventListener('load', boot);
})();
